import { lazyRenderWidgetByLoader } from 'core-components/helpers/lazyLoad'

export const WidgetSelectorOnboarding = (props: any) => {
  if (props.viewModel === 'request-detail-v2') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/modules/request'),
      props: { ...props.props, rid: Number(props.props.rid) },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'action-list-v2') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/modules/action/ui/ActionListWidget'),
      props: {
        ...props.props,
        rid: props.props.rid,
        flexWidth: props.props.flexWidth,
        metrics: props.props.metrics,
        aid: props.props.aid,
      },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'history-table-v2') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () =>
        import('legacy/lut/components/widgets/public/onboarding/requestsInfo/HistoryTimeline'),
      props: { ...props.props },
    })
  }

  if (props.viewModel === 'files-table-v2') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/modules/files'),
      props: { ...props.props, metrics: props.props.metrics, rid: props.props.rid },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'tab-buttons-v2') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/modules/tabs'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  if (props.viewModel === 'apl-ams-map-reconcile') {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: () => import('onboarding/modules/ams-map-reconcile'),
      props: { ...props.props },
      loadMeta: true,
    })
  }

  return null
}
